import { getApi } from "./api_instance";

export const retirementsTable = async (
  { filterData = null, page, pageSize, searchQuery },
  dispatch
) => {
  filterData = JSON.stringify(filterData);
  try {
    return await getApi({
      apiUrl: `/projects/api/retirements/all-retirements?filterData=${filterData}&page=${page}&pageSize=${pageSize}&searchQuery=${searchQuery}`,
      dispatch,
      sendToken: true,
    });
  } catch (error) {
    throw error;
  }
};
